import request from "@/utils/request"

// 检查并获取打印机编码
export const checkPrinterCode = function (query) {
  return request('get', '/api/printer/numberQuery', query)
}

// 激活打印机
export const activePrinter = function (params) {
  return request('post', '/api/printer/activate', params)
}

// 获取当前租户下打印机（已激活）
export const getPrintersOfTenant = function () {
  return request('get', '/api/user/getTenantPrinter')
}

// 断开连接
export const saveDisconnect = function (params) {
  return request('post', '/api/device/break', params)
}

// 查找上一次连接的设备信息
export const getLastConnect = function (query) {
  return request('get', '/api/device/find', query)
}

// 保存打印机连接信息
export const saveConnectInfo = function (params) {
  return request('post', '/api/device/connect', params)
}

export function getPrinterList(params) {
  return request('get', '/api/printer', params)
}

export function getTagList(params) {
  return request('get', '/api/code_trace', params)
}

// 获取租户选项
export function getTenantList(params) {
  return request('get', '/api/common/getTenant', params)
}

// 获取用户list
export function getUserList(params) {
  return request('get', '/api/user', params)
}